import { Button } from '@weareberyl/design-system'
import ServiceNowLogo from './ServiceNowLogo'
import { navigateToServiceNowAssets } from '~/components/Module/context'

const ServiceNowButton = ({
  assetTag,
  vehicleId,
  schemeId,
  fleetType,
  modelCategory,
}: {
  assetTag?: string
  vehicleId?: string
  schemeId?: string | null
  fleetType?: 'vehicle' | 'furniture' | 'none'
  modelCategory?: 'bay'
}) => {
  const serviceNowGreen = '#80b6A1'
  return (
    <Button
      variant="outline"
      onClick={() => {
        navigateToServiceNowAssets({
          assetTag,
          vehicleId,
          schemeId,
          fleetType,
          modelCategory,
        })
      }}
      width={48}
      // @ts-expect-error
      title={<ServiceNowLogo height={25} />}
      activeBorderColor={serviceNowGreen}
      borderColor={serviceNowGreen}
    />
  )
}

export default ServiceNowButton
